import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false }) => (
  <span
    className={`inline-flex items-center gap-3 font-mono text-xs uppercase tracking-[0.28em] ${
      dark ? "text-[#C87D55]" : "text-[#B36C45]"
    }`}
  >
    <span className="inline-block h-px w-8 bg-current" />
    {children}
  </span>
);
